import gql from "graphql-tag";

export const GET_AI_RECOMMENDATIONS = gql`
  query GetAiRecommendations($sessionId: String!, $category: String) {
    getAiRecommendations(sessionId: $sessionId, category: $category) {
      id
      sessionId
      flag
      url
      explanation
      fixInstructions
      priority
      estimatedImpact
      category
      isApplied
      createdAt
    }
  }
`;

export const GET_AI_ACTION_PLAN = gql`
  query GetActionPlan($sessionId: String!) {
    getActionPlan(sessionId: $sessionId) {
      id
      sessionId
      summary
      totalIssues
      criticalCount
      items
      createdAt
    }
  }
`;

export const GET_CHAT_HISTORY = gql`
  query GetChatHistory($projectId: String!, $limit: Int) {
    getChatHistory(projectId: $projectId, limit: $limit) {
      id
      role
      content
      metadata
      createdAt
    }
  }
`;

export const GET_AGENT_CONFIG = gql`
  query GetAgentConfig($projectId: String!) {
    getAgentConfig(projectId: $projectId) {
      id
      projectId
      isEnabled
      subAgents
      schedule
      lastRunAt
      createdAt
    }
  }
`;

export const GET_AGENT_TASK_LOGS = gql`
  query GetAgentTaskLogs($projectId: String!, $agentType: String, $limit: Int) {
    getAgentTaskLogs(projectId: $projectId, agentType: $agentType, limit: $limit) {
      id
      agentType
      action
      status
      result
      error
      duration
      createdAt
    }
  }
`;

export const GET_AGENT_SUMMARY = gql`
  query GetAgentSummary($projectId: String!) {
    getAgentSummary(projectId: $projectId)
  }
`;

export const GET_SMART_ALERTS = gql`
  query GetSmartAlerts($projectId: String, $unreadOnly: Boolean) {
    getSmartAlerts(projectId: $projectId, unreadOnly: $unreadOnly) {
      id
      userId
      projectId
      type
      severity
      title
      message
      data
      isRead
      createdAt
    }
  }
`;

export const GET_UNREAD_ALERT_COUNT = gql`
  query GetUnreadAlertCount {
    getUnreadAlertCount
  }
`;

export const GET_CONTENT_STRATEGIES = gql`
  query GetContentStrategies($projectId: String!) {
    getContentStrategies(projectId: $projectId) {
      id
      seedKeyword
      topics
      pillarPages
      clusterMap
      publishOrder
      status
      totalPieces
      completedPieces
      createdAt
    }
  }
`;

export const GET_CONTENT_STRATEGY_BY_ID = gql`
  query GetContentStrategyById($id: String!) {
    getContentStrategyById(id: $id) {
      id
      seedKeyword
      topics
      pillarPages
      clusterMap
      publishOrder
      status
      totalPieces
      completedPieces
      createdAt
    }
  }
`;

export const GET_AB_TESTS = gql`
  query GetAbTests($projectId: String!, $status: String) {
    getAbTests(projectId: $projectId, status: $status) {
      id
      projectId
      url
      testType
      originalValue
      variants
      activeVariant
      status
      startDate
      endDate
      results
      winnerIndex
      createdAt
    }
  }
`;

export const GET_AB_TEST_BY_ID = gql`
  query GetAbTestById($id: String!) {
    getAbTestById(id: $id) {
      id
      projectId
      url
      testType
      originalValue
      variants
      activeVariant
      status
      startDate
      endDate
      results
      winnerIndex
      createdAt
    }
  }
`;

export const GENERATE_ROBOTS_TXT = gql`
  query GenerateRobotsTxt($sessionId: String!) {
    generateRobotsTxt(sessionId: $sessionId) {
      content
      recommendations
    }
  }
`;

export const GENERATE_SITEMAP = gql`
  query GenerateSitemap($sessionId: String!) {
    generateSitemap(sessionId: $sessionId) {
      xml
      pageCount
      recommendations
    }
  }
`;

export const GENERATE_SCHEMA_MARKUP = gql`
  query GenerateSchemaMarkup($sessionId: String!, $url: String!) {
    generateSchemaMarkup(sessionId: $sessionId, url: $url) {
      url
      schemaType
      jsonLd
      recommendations
    }
  }
`;
